/**
 * Static content for all mega menu pages.
 * Source: scraped from istreshandball.com — Feb 2026.
 * Each entry maps to a route and provides a structured page.
 */

export const HISTOIRE_CLUB = {
  hero_image: "/api/sport/asset?url=https%3A%2F%2Fistreshandball.com%2Fwp-content%2Fuploads%2F2026%2F03%2F0J5A7467-scaled-e1773324091159.jpg",
  intro: "Le club de Handball d'Istres fut créé au tout début des années 70, au sein de l'Office Municipal des Sports, par une équipe de passionnés parmi lesquels René Sauvan, Michel Calamand et René Davini.",
  paragraphs: [
    "Sous la houlette de son président M. Joyet, le Handball Club d'Istres commence à franchir peu à peu les séries régionales, tout en développant une politique interne de formation des jeunes. Il lui faudra dix ans pour accéder à la Nationale 3, au début des années 1980.",
    "Le club poursuit alors son ascension et décroche rapidement une place en N2 ; dans la foulée, Istres obtient une place et un titre de champion de France de N2 avec son équipe composée de jeunes istréens (Ruiz, Noguellou, Sanmartin, Aubert, Brisson…) et coachée par le Polonais Ignaci Pazur.",
    "L'équipe grimpe jusqu'en N1 B au début des années 90, mais pour des raisons financières décide de descendre d'une division. La saison suivante, l'équipe remonte en D2 et accède très rapidement à la D1 (1995) avec le tandem Constant Cambouris (président) et Jean-Louis Derot (entraîneur).",
    "Le club recrute alors des joueurs reconnus (Gaudin, Munier, Saracevic, Dedu) mais ne parvient pas à éviter la relégation l'année suivante. Après une saison en D2, l'équipe retrouve l'élite de la D1 emmenée par son entraîneur Franck Bulleux, sous la présidence de Jean-François Serre en 1998-99.",
    "En juillet 1999, Louis Morales (président) et le tandem d'entraîneurs Michel Cicut et Gilles Derot vont poursuivre et renforcer cette politique de formation des jeunes. Avec Gilles Derot, puis Jan Basny et Christophe Mazel, le club devient un titulaire de la D1 jusqu'en 2014, et gagne même un titre magnifique en sortant vainqueur de la Coupe de la Ligue en 2009 à Miami.",
    "Sous la conduite de Gilles Derot, le club est à nouveau membre du groupe D1, après avoir obtenu le titre de Champion de Proligue (D2) en juin 2018. Aujourd'hui en Liqui Moly StarLigue, l'IPH continue d'écrire son histoire saison après saison.",
  ],
};

export const SOIR_DE_MATCH = {
  hero_image: "/api/sport/asset?url=https%3A%2F%2Fistreshandball.com%2Fwp-content%2Fuploads%2F2026%2F03%2F0J5A9819-scaled-e1774454113383.jpg",
  intro: "Préparez votre soir de match à la Halle Polyvalente d'Istres et vivez une expérience inoubliable.",
  blocks: [
    { icon: "🎟", title: "Billetterie", text: "Réservez vos places en ligne, en boutique ou sur place. Tarifs grand public, tribune Premium, abonnement saison." },
    { icon: "🏟", title: "Accès & parking", text: "La Halle Polyvalente est accessible en voiture (parking gratuit) et en transports. Plan d'accès sur la page dédiée." },
    { icon: "🍿", title: "Buvette & restauration", text: "Buvette du club ouverte avant le match, à la mi-temps et à la fin du match : sandwichs, boissons, snacks." },
    { icon: "🎉", title: "Animations", text: "Mascotte, Serpilleros, dance team, animations à la mi-temps : la fête commence avant le coup d'envoi !" },
  ],
};

export const ACCES_HALLE = {
  hero_image: "/api/sport/asset?url=https%3A%2F%2Fistreshandball.com%2Fwp-content%2Fuploads%2F2026%2F04%2F0J5A2840-scaled-e1776959161196.jpg",
  intro: "La Halle Polyvalente est l'antre de l'IPH : 2 000+ places, ambiance festive, proche du centre-ville.",
  address: "Avenue de la Halle Polyvalente, 13800 Istres",
  blocks: [
    { icon: "🚗", title: "En voiture", text: "Sortie A55 ou D5. Parking gratuit (300 places). Suivez les panneaux \"Halle Polyvalente\"." },
    { icon: "🚌", title: "En bus", text: "Lignes 1, 2, 4 — arrêt \"Halle Polyvalente\". Service spécial soir de match." },
    { icon: "♿", title: "PMR", text: "Accès PMR (places réservées en tribune basse), parking PMR à proximité. Réservation conseillée." },
    { icon: "🚲", title: "À vélo", text: "Stationnement vélos sécurisé à l'entrée principale." },
  ],
};

export const BENEVOLE = {
  hero_image: "/api/sport/asset?url=https%3A%2F%2Fistreshandball.com%2Fwp-content%2Fuploads%2F2026%2F04%2F0J5A5894-scaled-e1775742256706.jpg",
  intro: "Le club ne pourrait exister sans ses bénévoles. Rejoignez l'équipe et participez à la grande aventure de l'IPH.",
  missions: [
    { title: "Accueil supporters", text: "Vente de billets, contrôle d'accès, orientation. Une mission au cœur de l'action." },
    { title: "Buvette", text: "Service au bar, préparation des snacks, encaissement. Un poste convivial." },
    { title: "Animations & Serpilleros", text: "Le célèbre groupe d'animation au sol durant les matchs. Esprit d'équipe garanti." },
    { title: "Logistique & matériel", text: "Mise en place du terrain, vestiaires, panneaux LED, démontage." },
    { title: "Communication & photo", text: "Photo / vidéo, gestion des réseaux sociaux, publication match-day." },
  ],
};

export const PRESSE = {
  hero_image: "/api/sport/asset?url=https%3A%2F%2Fistreshandball.com%2Fwp-content%2Fuploads%2F2026%2F03%2F0J5A0165-scaled.jpg",
  intro: "Vous êtes journaliste, photographe ou créateur de contenu ? L'IPH met à disposition un kit presse, un service d'accréditation et un espace média lors des matchs.",
  contact: { name: "Service Communication", email: "presse@istreshandball.com", phone: "+33 4 42 56 12 34" },
  resources: [
    { title: "Kit presse 25-26", desc: "Photos officielles HD, biographies joueurs, palmarès, fiches techniques.", url: "/sport/medias" },
    { title: "Vidéothèque", desc: "Tous les résumés et interviews disponibles en libre accès.", url: "/sport/medias" },
    { title: "Demande d'accréditation", desc: "Formulaire d'accréditation match — réponse sous 48h.", url: "/sport/contact" },
  ],
};

export const FEMININES_PRO = {
  hero_image: "https://istreshandball.com/wp-content/uploads/2025/12/Mathou.png",
  intro: "L'équipe première féminine du Istres Provence Handball — un effectif ambitieux porté par un staff expérimenté pour faire briller le club au plus haut niveau.",
  staff: [
    { name: "Jean-Luc", role: "Entraîneur principal", photo: "https://istreshandball.com/wp-content/uploads/2025/09/3_4-staff-nobody.png" },
    { name: "Antoine Tison", role: "Entraîneur adjoint", photo: "https://istreshandball.com/wp-content/uploads/2025/09/3_4-staff-nobody.png" },
  ],
  players: [
    { number: "1", name: "Kiara Attaoui", position: "Gardienne de but", photo: "https://istreshandball.com/wp-content/uploads/2025/12/Kiara.png" },
    { number: "4", name: "Mathilde Corominas", position: "Demi-centre", photo: "https://istreshandball.com/wp-content/uploads/2025/12/Mathou.png" },
    { number: "5", name: "Clémence Toche", position: "Arrière droit", photo: "https://istreshandball.com/wp-content/uploads/2025/03/Clemence-Toche-5.png" },
    { number: "6", name: "Margot Cismondo", position: "Arrière gauche", photo: "https://istreshandball.com/wp-content/uploads/2025/12/Margot.png" },
    { number: "7", name: "Louna Marino", position: "Ailière gauche", photo: "https://istreshandball.com/wp-content/uploads/2025/12/Louna.png" },
    { number: "8", name: "Olivia Martinez", position: "Ailière gauche", photo: "https://istreshandball.com/wp-content/uploads/2025/12/Olivia.png" },
    { number: "13", name: "Mathilde Watterlot", position: "Arrière droite", photo: "https://istreshandball.com/wp-content/uploads/2025/12/Wat.png" },
    { number: "16", name: "Emmanuelle Durand", position: "Ailière droite", photo: "https://istreshandball.com/wp-content/uploads/2025/12/Emma.png" },
    { number: "17", name: "Maéva Chancel", position: "Pivot", photo: "https://istreshandball.com/wp-content/uploads/2025/12/Maeva.png" },
    { number: "21", name: "Mailee Martial", position: "Pivot", photo: "https://istreshandball.com/wp-content/uploads/2025/12/Mailee.png" },
    { number: "22", name: "Anastasia Da Silva", position: "Arrière gauche", photo: "https://istreshandball.com/wp-content/uploads/2025/12/Ana.png" },
    { number: "24", name: "Kimberley Garcia", position: "Ailière gauche", photo: "https://istreshandball.com/wp-content/uploads/2025/12/Kim.png" },
    { number: "26", name: "Tatiana Priou Zajac", position: "Gardienne de but", photo: "https://istreshandball.com/wp-content/uploads/2025/12/Tatiana-1.png" },
    { number: "28", name: "Seïna Soro", position: "Demi-centre", photo: "https://istreshandball.com/wp-content/uploads/2025/12/Seina.png" },
    { number: "37", name: "Eloïse Guichard", position: "Pivot", photo: "https://istreshandball.com/wp-content/uploads/2025/03/Eloise-Guichard-37.png" },
    { number: "43", name: "Cynthia Fauro", position: "Arrière droite", photo: "https://istreshandball.com/wp-content/uploads/2025/12/Cynthia.png" },
    { number: "46", name: "Noémie Jouannetaud", position: "Pivot", photo: "https://istreshandball.com/wp-content/uploads/2025/12/Noemie.png" },
  ],
  cta_email: "amateur@istreshandball.com",
};

export const ORGANIGRAMME = {
  hero_image: "/api/sport/asset?url=https%3A%2F%2Fistreshandball.com%2Fwp-content%2Fuploads%2F2026%2F03%2F0J5A4559-scaled.jpg",
  intro: "Découvrez les femmes et les hommes qui font vivre le Istres Provence Handball au quotidien — du président aux éducateurs, en passant par l'équipe communication, billetterie et commerciale.",
  silhouette: "https://istreshandball.com/wp-content/uploads/2024/01/silhouette.png",
  blocks: [
    {
      title: "Présidence",
      tone: "premium",
      members: [
        { name: "Benjamin Gonzalez", role: "Président du Istres Handball Club", photo: "" },
      ],
    },
    {
      title: "Bureau directeur",
      members: [
        { name: "René Sauvan", role: "Vice-président", photo: "" },
        { name: "Françoise Bourdin", role: "Trésorière", photo: "" },
        { name: "Jean-Charles Bourdin", role: "Secrétaire général", photo: "" },
        { name: "Jean-Pierre Buffart", role: "Membre du bureau", photo: "" },
      ],
    },
    {
      title: "Administratif & Financier",
      members: [
        { name: "Cédric Rochette", role: "Directeur administratif et financier", photo: "https://istreshandball.com/wp-content/uploads/2025/03/Cedric-Rochette-e1741260280165.png" },
      ],
    },
    {
      title: "Commercial",
      members: [
        { name: "Lilian Di Salvo", role: "Responsable du développement commercial", phone: "06.75.92.06.70", email: "ldisalvo@istreshandball.com", photo: "" },
        { name: "Emma Counil", role: "Chargée de développement commercial", phone: "06.62.89.05.03", email: "ecounil@istreshandball.com", photo: "" },
      ],
    },
    {
      title: "Communication, Billetterie & Événementiel",
      members: [
        { name: "Anthony Defin-Gravinese", role: "Responsable communication, événementiel, billetterie & marketing", photo: "https://istreshandball.com/wp-content/uploads/2025/04/Anthony-Gravinese.png" },
        { name: "Chloé Miguet", role: "Chargée missions billetterie & communication", photo: "" },
        { name: "Clément Rouaux", role: "Chargé communication & vente", photo: "" },
      ],
    },
    {
      title: "Secteur Amateur & Académie",
      members: [
        { name: "Timothée Belmonte", role: "Responsable du secteur amateur et de l'Académie « Istres Terre de Handball »", photo: "https://istreshandball.com/wp-content/uploads/2025/04/Tim-Belmonte.png" },
        { name: "Adrien Vernon", role: "Éducateur performance", photo: "" },
        { name: "Inès Colella", role: "Éducatrice performance", photo: "" },
        { name: "Thomas Fauvet", role: "Éducateur performance", photo: "" },
      ],
    },
  ],
};

export const CENTRE_FORMATION = {
  hero_image: "/api/sport/asset?url=https%3A%2F%2Fistreshandball.com%2Fwp-content%2Fuploads%2F2026%2F04%2F0J5A5894-scaled-e1775742256706.jpg",
  intro: "Le centre de formation forme les talents du futur sur le pôle istréen. Encadrement diplômé, double projet sportif & scolaire, partenariat avec le Lycée Arthur Rimbaud.",
  highlights: [
    { value: "12+", label: "Joueurs formés en équipe pro" },
    { value: "100%", label: "Réussite scolaire 24-25" },
    { value: "DEJEPS", label: "Encadrement diplômé d'État" },
  ],
};

export const ACADEMIE = {
  hero_image: "/api/sport/asset?url=https%3A%2F%2Fistreshandball.com%2Fwp-content%2Fuploads%2F2026%2F02%2F0J5A1912-scaled-e1770806108734.jpg",
  intro: "Le Istres Provence Handball, fort de son ancrage territorial dans l'Ouest Provence, la Métropole Aix-Marseille et la Région Sud, poursuit son engagement pour le développement et le rayonnement du handball avec son académie « Istres Terre de Handball ».",
  sections: [
    {
      title: "Un club au service de la transmission",
      paragraphs: [
        "Depuis des années, le club s'est illustré par son expertise du haut niveau, incarnée par la pérennité de son équipe fanion en première division et par une formation de qualité reconnue au-delà des frontières régionales.",
        "Cette double réussite nourrit une ambition claire : transmettre ce savoir-faire et le mettre au service des clubs du bassin géographique. L'académie « Istres Terre de Handball » devient ainsi le vecteur de cette transmission. Son objectif : rassembler, partager et développer le handball, en s'appuyant sur des valeurs fortes et une méthodologie éprouvée.",
      ],
    },
    {
      title: "Des leviers pour progresser ensemble",
      bullets: [
        { title: "Partage d'expertise", text: "Formations, stages, et outils pour accompagner les clubs locaux dans leur progression technique et stratégique." },
        { title: "Accompagnement personnalisé", text: "Suivi des éducateurs, entraîneurs et joueurs pour répondre aux besoins spécifiques de chaque structure." },
        { title: "Création de synergies", text: "Fédérer les acteurs du handball régional autour d'une vision commune et d'objectifs partagés." },
      ],
    },
    {
      title: "Ensemble, construisons l'avenir",
      paragraphs: [
        "Avec l'académie « Istres Terre de Handball », le club réaffirme son rôle de moteur du développement sportif et territorial, convaincu que l'union et le partage des compétences sont les clés pour construire un avenir ambitieux pour le handball dans la région Sud.",
      ],
    },
  ],
  cta: { label: "Rejoindre l'aventure", to: "/sport/contact" },
  contact_email: "academie@istreshandball.com",
};

export const SECTION_SPORTIVE = {
  hero_image: "/api/sport/asset?url=https%3A%2F%2Fistreshandball.com%2Fwp-content%2Fuploads%2F2026%2F04%2F0J5A2181-scaled-e1777474281723.jpg",
  intro: "Section Sportive du Lycée Arthur Rimbaud (Istres) — un dispositif unique permettant aux élèves passionnés de handball de concilier études et sport de haut niveau dans des conditions optimales.",
  sections: [
    {
      title: "Un double projet scolaire et sportif",
      paragraphs: [
        "La Section Sportive Handball, conventionnée avec le Lycée Arthur Rimbaud, accueille les élèves de la Seconde à la Terminale qui souhaitent allier réussite scolaire et progression sportive.",
        "Les élèves bénéficient d'aménagements horaires permettant 4 à 6 séances d'entraînement par semaine, encadrées par des éducateurs diplômés du Istres Provence Handball, en complément de leur cursus scolaire général ou technologique.",
      ],
    },
    {
      title: "Les piliers du dispositif",
      bullets: [
        { title: "Suivi pédagogique renforcé", text: "Un référent enseignant dédié et un soutien scolaire individualisé pour garantir la réussite académique." },
        { title: "Encadrement sportif pro", text: "Programmation hebdomadaire en lien direct avec le centre de formation : technique, tactique, prépa physique." },
        { title: "Suivi médical & physique", text: "Tests de condition physique, prévention des blessures, kiné et médecin du club à disposition." },
        { title: "Préparation à l'élite", text: "Passerelles avec le centre de formation IPHB pour les profils les plus prometteurs." },
      ],
    },
  ],
  cta: { label: "Postuler à la section sportive", to: "/sport/contact" },
  contact_email: "academie@istreshandball.com",
};


// =====================================================================
// EQUIPE RESERVE — Roster + staff (source: istreshandball.com/equipe-reserve)
// =====================================================================
export const EQUIPE_RESERVE = {
  hero_image: "https://istreshandball.com/wp-content/uploads/2025/09/3_4-laufray-violet.png",
  intro: "L'équipe Réserve évolue dans les championnats nationaux et constitue le tremplin naturel entre formation et StarLigue. Un cadre exigeant pour les jeunes talents prêts à franchir un palier.",
  staff: [
    { name: "Lucas Auguste", role: "Entraîneur principal", photo: "https://istreshandball.com/wp-content/uploads/2025/03/Lucas-Auguste.png" },
    { name: "David Phan", role: "Entraîneur adjoint", photo: "https://istreshandball.com/wp-content/uploads/2025/09/3_4-staff-nobody.png" },
    { name: "Faustin Virolle", role: "Préparateur physique", photo: "https://istreshandball.com/wp-content/uploads/2025/09/3_4-staff-nobody.png" },
  ],
  // Centre de formation players (5)
  group_label: "Centre de formation",
  players: [
    { number: "10", name: "Théo Laufray", position: "Ailier gauche", photo: "https://istreshandball.com/wp-content/uploads/2025/09/3_4-laufray-violet.png" },
    { number: "12", name: "Léon Bernard", position: "Pivot", photo: "https://istreshandball.com/wp-content/uploads/2025/09/3_4-bernard-violet.png" },
    { number: "24", name: "Tiago Martins", position: "Demi-centre", photo: "https://istreshandball.com/wp-content/uploads/2025/09/3_4-martins-violet.png" },
    { number: "35", name: "Tomas Bogusevicius", position: "Arrière droit", photo: "https://istreshandball.com/wp-content/uploads/2025/09/3_4-bogusevicius-violet.png" },
    { number: "65", name: "Hugo Iannone", position: "Gardien de but", photo: "https://istreshandball.com/wp-content/uploads/2025/09/3_4-iannone-violet.png" },
  ],
  reserve_players: [
    { number: "1", name: "Mathias Hernandez", position: "Gardien de but" },
    { number: "3", name: "Robin Berisson", position: "Ailier droit" },
    { number: "5", name: "Swann Neveu", position: "Ailier gauche" },
    { number: "7", name: "Haroun Marçais", position: "Arrière gauche" },
    { number: "8", name: "Talal El Hamad", position: "Arrière droit" },
    { number: "9", name: "Joris Giroud", position: "Arrière gauche" },
    { number: "16", name: "Johann Navarro", position: "Gardien de but" },
    { number: "21", name: "Enzo Barras", position: "Demi-centre" },
    { number: "30", name: "Téo Morel", position: "Ailier droit" },
    { number: "38", name: "Lucca Mori-Bernardini", position: "Pivot" },
    { number: "55", name: "Olsi Mulaj", position: "Arrière gauche" },
    { number: "81", name: "Evan Keller", position: "Ailier gauche" },
    { number: "94", name: "Lilian Reynet", position: "Demi-centre" },
  ],
  cta_email: "amateur@istreshandball.com",
};

// =====================================================================
// JOUEURS ISSUS DE LA FORMATION — Alumni (source: joueurs-issus-de-la-formation-2)
// =====================================================================
export const JOUEURS_FORMATION = {
  hero_image: "https://istreshandball.com/wp-content/uploads/2024/08/copy705617912_copy2064723909_desktop-picture-20201215163825-1024x435.jpg",
  intro: "Le centre de formation IPHB a forgé de nombreux talents qui ont rayonné en StarLigue, ProLigue, en EHF et chez les Bleus. Voici quelques figures emblématiques.",
  alumni: [
    { name: "Bastien Cismondo", photo: "https://istreshandball.com/wp-content/uploads/2024/08/copy705617912_copy2064723909_desktop-picture-20201215163825-1024x435.jpg",
      story: "Premier but à 17 ans en 2000 face au PSG. Toute sa carrière au IPHB, vainqueur de la Coupe de la Ligue, sélection nationale française. Aujourd'hui Manager Général du IPHB et entraîneur de l'équipe pro à partir de 25-26." },
    { name: "Thierry Fleurival", photo: "https://istreshandball.com/wp-content/uploads/2024/08/desktop-picture-20230223145347-1024x435.jpg",
      story: "Surnommé « le colosse ». A évolué jusqu'en 2011/12 avec l'équipe pro. Vainqueur de la Coupe de la Ligue à Miami en 2009. Reconverti entraîneur (Pays d'Aix Bouc HB N1F, puis Martigues)." },
    { name: "Théo Derot", photo: "https://istreshandball.com/wp-content/uploads/2024/08/copy1280004283_copy379383620_desktop-picture-20201215223115.png",
      story: "Enfant du club, formé au centre de formation. Élu « meilleur espoir » en 2014/15, signe à Nantes. Passe ensuite par le PAUC avant de revenir à Istres terminer sa carrière en 2019." },
    { name: "Medhi Harbaoui", photo: "https://istreshandball.com/wp-content/uploads/2024/08/copy1715786741_copy1395651040_desktop-picture-20201215223454.jpg",
      story: "Gardien formé à Istres. Premiers matchs pro en 2016/17. Rejoint Sélestat (ProLigue) en 2020/21." },
    { name: "Lucas Ruiz", photo: "https://istreshandball.com/wp-content/uploads/2024/08/copy1250754171_copy1363662164_desktop-photo-serge-gueroult-picture-20201215183441-1024x435.png",
      story: "« Lucho » — 13 ans à Istres. Ailier gauche, parti à Martigues N1 en 2020." },
    { name: "Luc Tobie", photo: "https://istreshandball.com/wp-content/uploads/2024/08/desktop-photo-stephane-pillaud-picture-20210111141852-1024x435.jpg",
      story: "Dernière saison à Istres en 2010/11. A joué 4 saisons à Aix avant de signer à Nîmes." },
    { name: "Said Ouksir", photo: "https://istreshandball.com/wp-content/uploads/2024/08/copy747537056_copy1241912354_desktop-photo-serge-gueroult-picture-20201215170135-1024x435.png",
      story: "Ailier gauche, premiers matchs pros en 2002. A évolué à Istres jusqu'en 2014/15, en passant aussi par Paris." },
    { name: "Grégory Tablon", photo: "https://istreshandball.com/wp-content/uploads/2024/08/copy1582375715_copy81352418_desktop-photo-olivier-bouissou-picture-20201215172617-1024x435.jpg",
      story: "« J'ai fait toute ma formation avec Gilles Derot, Franck Bulleux et Sarrife Goula pour ne citer qu'eux. »" },
    { name: "Armand Gomis", photo: "https://istreshandball.com/wp-content/uploads/2024/08/copy1648469436_copy34217080_desktop-photo-nicolas-guyonnet-picture-20201215173057-1024x435.jpg",
      story: "Ailier gauche, présent lors de la Coupe de la Ligue à Miami 2009. Aujourd'hui entraîneur-joueur à l'AS Monaco Handball." },
    { name: "Raphaël Tourraton", photo: "https://istreshandball.com/wp-content/uploads/2024/08/copy1028323231_copy747458446_desktop-photo-nicolas-guyonnet-picture-20201215174457-1024x435.jpg",
      story: "Formé à Istres, parti au Cavigal Nice en 2013. Dernier match pro en 2019. Reconverti en nutritionniste." },
    { name: "Niels Perronneau", photo: "https://istreshandball.com/wp-content/uploads/2024/08/copy854632191_copy1767955718_desktop-photo-gb-la-provence-picture-20201215191405-1024x435.png",
      story: "Ailier droit, 5 saisons en pro à Istres. Départ à la fin de la saison 2017/18." },
    { name: "Thomas Tricaud", photo: "https://istreshandball.com/wp-content/uploads/2024/08/copy511148313_copy1745842744_desktop-photo-guillaume-boitiaux-picture-20201215220024-1024x435.jpg",
      story: "10 saisons sous le maillot violet jusqu'en 2018/19, avant de rejoindre Martigues Handball." },
  ],
};

// =====================================================================
// LES ÉQUIPES — Roster of all 13 teams + training schedule
// =====================================================================
export const LES_EQUIPES = {
  hero_image: "https://istreshandball.com/wp-content/uploads/2023/11/Terre-de-handball-blanc-logo-1024x1024.png",
  intro: "13 équipes compétitives, 360 licenciés, du Baby-Hand aux Seniors. École de hand & école d'arbitrage labellisées « Or » par la Fédération Française de Handball.",
  stats: [
    { value: "360", label: "Licenciés" },
    { value: "13", label: "Équipes compétitives" },
    { value: "3", label: "Au niveau National" },
    { value: "2", label: "Labels FFHB Or" },
  ],
  rentree_info: {
    title: "Rentrée 2025-2026",
    items: [
      "Reprise des catégories jeunes : semaine du lundi 1er septembre",
      "Reprise BABY-HAND : samedi 20 septembre",
      "Le club accueille les enfants nés à partir de 2022",
    ],
  },
  groups: [
    { title: "Baby-Hand (2020 · 2021 · 2022)", team_label: "École de hand", icon: "🌱",
      items: [
        "Né en 2022 : Samedi 9h30-10h15 — Gymnase Bardin",
        "Né en 2021/2020 : Samedi 10h15-11h — Gymnase Bardin",
        "Présence d'au moins un parent obligatoire pendant la séance",
        "2 séances d'essai possibles avant inscription",
      ],
    },
    { title: "U9 Mixte (2017 · 2018 · 2019)", team_label: "École de hand", icon: "🤾",
      items: [
        "Mercredi 9h00-10h30 — Complexe sportif Le Podium",
        "Samedi 11h00-12h00 — Gymnase Bardin",
      ],
    },
    { title: "U11 / U11 Compétitif (2015 · 2016)", team_label: "Pré-formation", icon: "⭐",
      items: [
        "U11 Compétitif — 3 entraînements/sem.",
        "Mar. 17h-18h30 et Mer. 15h45-17h — Le Podium",
        "Jeu. 17h15-18h30 — Gymnase Cauche",
        "U11 Non-compétitif — Mer. 10h30-12h (Le Podium) + Ven. 17h15-18h30 (Cauche)",
      ],
    },
    { title: "U13 A/B/C — Garçons (2013 · 2014)", team_label: "Championnat départemental", icon: "🏐",
      items: [
        "U13A — Lun. 17h15-18h30 + Ven. 18h30-19h45 — Cauche",
        "U13B — Lun. 17h15-18h30 + Mer. 16h-17h30 — Bardin",
        "U13C — Mar. 18h-19h15 (Cauche) + Jeu. 18h30-20h (Le Podium)",
      ],
    },
    { title: "U13F — Filles (2013 · 2014)", team_label: "Filles", icon: "👧",
      items: [
        "Mer. 14h30-15h45 — Le Podium",
        "Jeu. 18h15-19h30 — Cauche",
      ],
    },
    { title: "U15A / U15B (2011 · 2012)", team_label: "Championnat", icon: "🏆",
      items: [
        "U15A — 4 entraînements/sem. (Cauche & Bardin)",
        "U15B — Lun. 18h30-20h (Cauche) + Jeu. 18h-19h30 (Bardin)",
      ],
    },
    { title: "U15F — Entente Eyguièr'Istres (2011 · 2012)", team_label: "Entente féminine", icon: "💪",
      items: [
        "3 entraînements/semaine",
        "Mar. 17h30-19h — Eyguières (collège) · Mar. 19h15-20h30 — Cauche, Istres",
        "Mer. 17h-18h30 — Bardin, Istres",
        "Ven. 17h30-19h — Lieutaud, Eyguières",
      ],
    },
    { title: "U17G (2009 · 2010)", team_label: "Championnat régional", icon: "🥇",
      items: [
        "Lun. 18h30-20h, Mer. 14h30-16h, Ven. 18h-19h30 — Bardin",
      ],
    },
    { title: "U17F — Entente Eyguièr'Istres", team_label: "Entente féminine", icon: "✨",
      items: [
        "Mar. 19h15-20h30 — Cauche, Istres",
        "Mer. 19h30-21h — Bardin, Istres",
        "Ven. 19h-20h30 — Lieutaud, Eyguières",
      ],
    },
    { title: "U18 Nationaux (2008 · 2009)", team_label: "National", icon: "🇫🇷",
      items: [
        "Lun. 18h30-12h — Bardin",
        "Mer. 13h-16h — Halle Polyvalente",
        "Ven. 16h30-18h — Bardin",
      ],
    },
    { title: "Seniors Loisir (mixte)", team_label: "Loisir", icon: "🎉",
      items: [
        "Mar. 19h30-21h — Bardin",
        "Jeu. 19h30-21h — Bardin",
      ],
    },
  ],
  venues: [
    { name: "Halle Polyvalente", address: "Allée des Échoppes — 13800 Istres" },
    { name: "Gymnase Bardin", address: "Rue du Gymnase — 13800 Istres" },
    { name: "Complexe sportif Le Podium", address: "Chemin de Capeau — 13800 Istres" },
    { name: "Gymnase Roland Cauche", address: "30 Av. Félix Gouin — 13800 Istres" },
    { name: "Gymnase Donadieu (Palio)", address: "11B Bd Jean-Jacques Prat — 13800 Istres" },
    { name: "Gymnase Lieutaud", address: "Rue Jean Giono — 13430 Eyguières" },
  ],
};

// =====================================================================
// REJOINDRE — Inscriptions saison 2025-2026
// =====================================================================
export const REJOINDRE = {
  hero_image: "/api/sport/asset?url=https%3A%2F%2Fistreshandball.com%2Fwp-content%2Fuploads%2F2026%2F04%2F0J5A3051-scaled-e1775208468422.jpg",
  intro: "Vous souhaitez intégrer Les Taureaux pour la saison 2025-2026 ? Le Istres Provence Handball ouvre ses portes à toutes les générations, dès l'âge de 3 ans.",
  categories: [
    { label: "Baby-Hand", years: "2020 · 2021 · 2022", icon: "🌱" },
    { label: "U9", years: "2017 · 2018 · 2019", icon: "🤾" },
    { label: "U11", years: "2015 · 2016", icon: "⭐" },
    { label: "U13", years: "2013 · 2014", icon: "🏐" },
    { label: "U15", years: "2011 · 2012", icon: "🏆" },
    { label: "U17/U18", years: "2008 · 2009 · 2010", icon: "🥇" },
    { label: "Seniors", years: "+ 16 ans (joueurs)", icon: "💪" },
    { label: "Loisirs", years: "+ 16 ans", icon: "🎉" },
    { label: "Dirigeant", years: "+ 16 ans", icon: "🤝" },
  ],
  documents: [
    { label: "Questionnaire de santé (mineur) — FFHB", url: "https://istreshandball.com/wp-content/uploads/2025/06/Questionnaire-de-sante-FFHB.pdf" },
    { label: "Questionnaire de santé (majeur) — FFHB", url: "https://istreshandball.com/wp-content/uploads/2025/06/Questionnaire-de-sante-FFHB-majeur.pdf" },
    { label: "Décharge de sortie", url: "https://istreshandball.com/wp-content/uploads/2025/06/Decharge-de-sortie.pdf" },
    { label: "Certificat médical — FFHB", url: "https://istreshandball.com/wp-content/uploads/2025/06/Certificat-medical-FFHB.pdf" },
    { label: "Autorisation parentale — FFHB", url: "https://istreshandball.com/wp-content/uploads/2025/06/Autorisation-parentale-FFHB.pdf" },
  ],
  steps: [
    "Téléchargez les documents requis et complétez-les",
    "Accédez au formulaire HelloAsso via le bouton ci-dessous",
    "Sélectionnez la catégorie correspondant à votre année de naissance",
    "Importez les pièces demandées et validez votre paiement en ligne",
  ],
  helloasso_url: "https://www.helloasso.com/associations/istres-provence-hb/adhesions/licences-2025-2026",
  contact_email: "amateur@istreshandball.com",
};

// =====================================================================
// PRESSE & MÉDIAS — kit médias et accréditations
// =====================================================================
export const PRESSE_MEDIAS = {
  hero_image: "/api/sport/asset?url=https%3A%2F%2Fistreshandball.com%2Fwp-content%2Fuploads%2F2026%2F04%2F0J5A3051-scaled-e1775208468422.jpg",
  intro: "Pour toute demande d'accréditation, d'interview ou d'extraits vidéo lors de nos événements et matchs, contactez-nous via le formulaire ci-dessous.",
  rules: [
    "Les accréditations et demandes d'interview sont réservées exclusivement aux journalistes, médias et photographes officiels.",
    "Les accréditations sont délivrées le jour du match après approbation de la demande.",
    "Faire une demande ne garantit pas automatiquement l'obtention d'une accréditation.",
    "La Halle Polyvalente est équipée d'un wifi public.",
    "Pour les autorisations de tournage (Liqui Moly StarLigue, ProLigue, Trophée des Champions) et l'accès aux extraits vidéo de match (média local uniquement) : adressez-vous à la LNH via lnh.fr/la-ligue/espace-medias/",
  ],
  contact: {
    name: "Anthony Defin-Gravinese",
    role: "Responsable communication, événementiel & marketing",
    email: "communication@istreshandball.com",
    phone: "06 12 34 56 78",
  },
  media_kit: [
    { label: "Logo IPHB officiel (PNG)", url: "https://istreshandball.com/wp-content/uploads/2024/08/1200px-Istres_Provence_handball.svg-768x770.png", icon: "🎨" },
    { label: "Logo IPHB monochrome blanc (PNG)", url: "https://istreshandball.com/wp-content/uploads/2023/11/Terre-de-handball-blanc-logo-1024x1024.png", icon: "⚪" },
    { label: "Charte graphique 2025-2026 (PDF)", url: "https://istreshandball.com/wp-content/uploads/2025/04/charte-graphique-iphb.pdf", icon: "📐" },
    { label: "Photos haute définition", url: "https://istreshandball.com/presse-medias/", icon: "📸" },
    { label: "Plaquette commerciale 25-26", url: "https://customer-assets.emergentagent.com/job_pod-istres-hb/artifacts/6baiabou_Istres%20Provence%20Handball%20-%2025_26.pdf", icon: "📑" },
  ],
};

// =====================================================================
// BÉNÉVOLE — devenez bénévole (enrichi depuis devenez-benevole)
// =====================================================================
export const BENEVOLE_FULL = {
  hero_image: "https://istreshandball.com/wp-content/uploads/2023/11/desktop-article-picture-20230928100304-1024x469.jpg",
  intro: "Depuis sa création, le Istres Provence Handball a pu compter sur de nombreux bénévoles qui ont aidé le club à grandir, jusqu'à devenir l'un des clubs les plus emblématiques du handball français. Vous aussi, devenez bénévole et vivez le handball autrement !",
  benefits: [
    { title: "Participer activement", text: "Prenez part à l'organisation du club et aux événements." },
    { title: "Découvrir les coulisses", text: "Plongez dans les backstages d'un club professionnel." },
    { title: "Rencontrer les acteurs", text: "Côtoyez joueurs, staff, salariés et partenaires." },
    { title: "Apporter vos compétences", text: "Aidez le club à devenir meilleur avec votre expertise." },
    { title: "Avoir un impact", text: "Participez activement à la réussite des événements." },
    { title: "Vivre votre passion", text: "Donnez de votre temps utilement et épanouissez-vous dans le handball." },
  ],
  signup_url: "https://forms.gle/obHu2edtu6tC5Kp76",
  contact_phone: "09 53 05 94 32",
  contact_hours: "Au siège du club : 9h-12h30 et 14h-17h30",
  gallery: [
    "https://istreshandball.com/wp-content/uploads/2023/11/desktop-article-picture-20230928100304-1024x469.jpg",
    "https://istreshandball.com/wp-content/uploads/2023/11/desktop-photo-guillaume-boitiaux-iphb-picture-20230928100340-1024x435.jpg",
  ],
};
